import React from 'react';
import { connect } from 'react-redux';
import { LOCAL_KEYS } from '../../constants/localStorageKeys';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';
import { PAGE_ROUTES } from '../../constants/pageRoutes';
import { adjustCheckInCheckoutDates } from '../goButton/component';

const mapStateToProps = state => ({
  search: state.Search,
});

class ViewFeaturedListingsButtons extends React.Component {

  constructor(props) {
    super(props);

    this.saveSearchFilters = this.saveSearchFilters.bind(this);
  }

  saveSearchFilters = () => {
    const { filters } = this.props.search;
    let newFilters = { ...filters };

    const radius = document.getElementById("radius") ? document.getElementById("radius").value : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_RADIUS;
    const lat = document.getElementById("lat") ? document.getElementById("lat").value : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_LATITUDE;
    const long = document.getElementById("long") ? document.getElementById("long").value : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_LONGITUDE;

    if (radius && lat && long) {
      newFilters.geometry = {
        lat: Number(lat),
        lng: Number(long)
      }
      newFilters.radius = radius;
    }

    newFilters = adjustCheckInCheckoutDates(newFilters);
    localStorage.setItem(LOCAL_KEYS.FILTER_VALUES, JSON.stringify(newFilters));
  }

  goToSearch = () => {
    this.saveSearchFilters();
    window.location.href = `/app/#${PAGE_ROUTES.SEARCH}`;
  }

  render() {
    return (
      <button type="button" className="btn secondary" onClick={this.goToSearch}>View all Listings</button>
    )
  }
}

export default connect(mapStateToProps)(ViewFeaturedListingsButtons);
